<ng-container *ngIf="element?.context as context">
    <app-timeline
        [points]="context.points"
        [currentIndex]="context.currentIndex"
    ></app-timeline>
</ng-container>
